import _objectSpread from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
var DEFAULT_OPTIONS = {
  attack: 0.003,
  channelCount: 2,
  channelCountMode: 'clamped-max',
  channelInterpretation: 'speakers',
  knee: 30,
  ratio: 12,
  release: 0.25,
  threshold: -24
};
export var createDynamicsCompressorNodeConstructor = function createDynamicsCompressorNodeConstructor(audioNodeConstructor, createAudioParam, createDynamicsCompressorNodeRenderer, createNativeDynamicsCompressorNode, createNotSupportedError, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(DynamicsCompressorNode, _audioNodeConstructor);
    function DynamicsCompressorNode(context, options) {
      var _this;
      _classCallCheck(this, DynamicsCompressorNode);
      var nativeContext = getNativeContext(context);
      var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options);
      var nativeDynamicsCompressorNode = createNativeDynamicsCompressorNode(nativeContext, mergedOptions);
      var isOffline = isNativeOfflineAudioContext(nativeContext);
      var dynamicsCompressorNodeRenderer = isOffline ? createDynamicsCompressorNodeRenderer() : null;
      _this = _possibleConstructorReturn(this, _getPrototypeOf(DynamicsCompressorNode).call(this, context, false, nativeDynamicsCompressorNode, dynamicsCompressorNodeRenderer));
      _this._attack = createAudioParam(_assertThisInitialized(_assertThisInitialized(_this)), isOffline, nativeDynamicsCompressorNode.attack);
      _this._knee = createAudioParam(_assertThisInitialized(_assertThisInitialized(_this)), isOffline, nativeDynamicsCompressorNode.knee);
      _this._nativeDynamicsCompressorNode = nativeDynamicsCompressorNode;
      _this._ratio = createAudioParam(_assertThisInitialized(_assertThisInitialized(_this)), isOffline, nativeDynamicsCompressorNode.ratio);
      _this._release = createAudioParam(_assertThisInitialized(_assertThisInitialized(_this)), isOffline, nativeDynamicsCompressorNode.release);
      _this._threshold = createAudioParam(_assertThisInitialized(_assertThisInitialized(_this)), isOffline, nativeDynamicsCompressorNode.threshold);
      setAudioNodeTailTime(_assertThisInitialized(_assertThisInitialized(_this)), 0.006);
      return _this;
    }
    _createClass(DynamicsCompressorNode, [{
      key: "attack",
      get: function get() {
        return this._attack;
      } // Bug #108: Safari allows a channelCount of three and above which is why the getter and setter needs to be overwritten here.
    }, {
      key: "channelCount",
      get: function get() {
        return this._nativeDynamicsCompressorNode.channelCount;
      },
      set: function set(value) {
        var previousChannelCount = this._nativeDynamicsCompressorNode.channelCount;
        this._nativeDynamicsCompressorNode.channelCount = value;
        if (value > 2) {
          this._nativeDynamicsCompressorNode.channelCount = previousChannelCount;
          throw createNotSupportedError();
        }
      }
      /*
       * Bug #109: Only Chrome and Firefox disallow a channelCountMode of 'max' yet which is why the getter and setter needs to be
       * overwritten here.
       */
    }, {
      key: "channelCountMode",
      get: function get() {
        return this._nativeDynamicsCompressorNode.channelCountMode;
      },
      set: function set(value) {
        var previousChannelCount = this._nativeDynamicsCompressorNode.channelCountMode;
        this._nativeDynamicsCompressorNode.channelCountMode = value;
        if (value === 'max') {
          this._nativeDynamicsCompressorNode.channelCountMode = previousChannelCount;
          throw createNotSupportedError();
        }
      }
    }, {
      key: "knee",
      get: function get() {
        return this._knee;
      }
    }, {
      key: "ratio",
      get: function get() {
        return this._ratio;
      }
    }, {
      key: "reduction",
      get: function get() {
        // Bug #111: Safari returns an AudioParam instead of a number.
        if (typeof this._nativeDynamicsCompressorNode.reduction.value === 'number') {
          return this._nativeDynamicsCompressorNode.reduction.value;
        }
        return this._nativeDynamicsCompressorNode.reduction;
      }
    }, {
      key: "release",
      get: function get() {
        return this._release;
      }
    }, {
      key: "threshold",
      get: function get() {
        return this._threshold;
      }
    }]);
    return DynamicsCompressorNode;
  }(audioNodeConstructor);
};